module.exports = __webpack_public_path__ + "img/ic-action-decrease.663d62a8.svg";